import type { GroupDetailResult } from '@wlb/shared/api/services/groupService';

/**
 * Owner/admin check for a loaded group. GetGroupDetails reports the flags on
 * the meta envelope, while the mapped record carries them too depending on the
 * membership payload, so both are consulted.
 */
export const isGroupAdmin = (detail: GroupDetailResult | null): boolean =>
  detail?.meta.isOwner === true ||
  detail?.meta.isAdmin === true ||
  detail?.data.isOwner === true ||
  detail?.data.isAdmin === true;
